import React, { useEffect, useState } from 'react';
import { LegalDocumentView } from '@/components/LegalDocumentView';
import { fetchCurrentLegalDoc } from './useLegalDoc';

export default function TermsPage() {
  const [doc, setDoc] = useState<Awaited<ReturnType<typeof fetchCurrentLegalDoc>> | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchCurrentLegalDoc('terms')
      .then((d) => {
        setDoc(d);
        setError(null);
      })
      .catch((e) => setError(e instanceof Error ? e.message : 'Failed to load Terms'));
  }, []);

  if (error) return <div className="panel"><div className="alert alert-error">{error}</div></div>;
  if (!doc) return <div className="panel">Loading Terms…</div>;
  return <LegalDocumentView doc={doc} />;
}
